import {Dashboard} from '../../dashboards/dashboards.types';

export default function getDashboardName(dashboard: Dashboard): string {
  if (!dashboard) return '';

  return dashboard.name || `Dashboard ${dashboard.id}`;
}
